if (!customElements.get("variant-selects")) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onVariantChange);
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantStatuses();
      this.updateKeyDetails();
      if (this.currentVariant) {
        this.updateURL();
        this.updateVariantInput();
      }
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value
      );
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(this.dataset.formId);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        let variantEvent = new CustomEvent("variant:changed", {
          bubbles: true,
          detail: {
            variant: this.currentVariant,
          },
        });
        productForm.dispatchEvent(variantEvent);
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(":checked").value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll(".product-form__input")];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked").value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.innerText = input.getAttribute("value");
        } else {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        }
      });
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        getJson(
          this.querySelector('[type="application/json"].product-variants')
            .textContent
        );
      return this.variantData;
    }

    updateFinalPrice() {
      const finalPriceElms = document.querySelectorAll(
        "[data-product-final-price]"
      );
      let currentPrice = this.currentVariant.price;
      if (!finalPriceElms) return;
      finalPriceElms.forEach(
        (priceEl) => (priceEl.innerHTML = Shopify.formatMoney(currentPrice))
      );
    }
    
    updateKeyDetails() {
      const mainKeyDetails = document.querySelector("[data-key-details-main]");
      const keyDetailsPerVariant = document.querySelectorAll("[data-key-details-variant]");
      if(!keyDetailsPerVariant.length) return;
      let keyDetailsCurrentVariant = false;
      keyDetailsPerVariant.forEach((el) => {
        if(el.dataset.keyDetailsVariant == this.currentVariant.id) {
          el.classList.remove("td-hide");
          keyDetailsCurrentVariant = true;
        } else {
          el.classList.add("td-hide");
        }
      })
      if(!mainKeyDetails) return;
      keyDetailsCurrentVariant ? mainKeyDetails.classList.add("td-hide") : mainKeyDetails.classList.remove("td-hide");
    }
  }

  customElements.define("variant-selects", VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
      this.OPTION_SELECTOR = this.querySelector(".td-product__form__options");
    }

    // ------------TD CHANGE-----------
    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
    }

    // --------- END TD CHANGE--------
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.classList.remove("disabled");
        } else {
          input.classList.add("disabled");
        }
      });
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
      this.updateScents();
    }

    updateScents() {
      const pickerWrappers = this.querySelectorAll('[data-scent-picker]');
      if (!pickerWrappers.length) return;

      let allSelectedScents = [];

      pickerWrappers.forEach((pickerWrapper) => {
        const activeScent = Array.from(pickerWrapper.querySelectorAll("input"))
          .find((radio) => radio.checked)?.value;
        if (activeScent) {
          allSelectedScents.push(activeScent);
        }

        const scentDependent = pickerWrapper.querySelectorAll('[data-scent]');
        scentDependent.forEach((scentEl) => {
          if (scentEl.dataset?.scent === activeScent) {
            scentEl.classList.remove('td-hide');
          } else {
            scentEl.classList.add('td-hide');
          }
        });
      });

      // Handle [data-scent] elements outside of [data-scent-picker]
      const globalScentDependent = document.querySelectorAll('[data-scent]');
      globalScentDependent.forEach((scentEl) => {
        if (!scentEl.closest('[data-scent-picker]')) {
          if (allSelectedScents.includes(scentEl.dataset?.scent)) {
            scentEl.classList.remove('td-hide');
          } else {
            scentEl.classList.add('td-hide');
          }
        }
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("quantity-input")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.changeEvent = new Event("change", { bubbles: true });

      this.input.addEventListener("change", this.onInputChange.bind(this));
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.validateQtyRules();
      //this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }

    onInputChange(event) {
      this.validateQtyRules();
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(
          ".quantity__button[name='minus']"
        );
        buttonMinus.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }
  }

  customElements.define("quantity-input", QuantityInput);
}

if (!customElements.get("selling-plans")) {
  class SellingPlans extends HTMLElement {
    constructor() {
      super();
      this.relatedForm = this.dataset.formId
        ? document.querySelector("#" + this.dataset.formId)
        : false;
      this.purchaseOptions = document.querySelectorAll(
        "input[name='selling_plan_type']"
      );
      this.purchaseOptionsRef = document.querySelectorAll(
        "input[name='selling_plan_type_ref']"
      );
      this.priceReferences = document.querySelectorAll(
        ".td-product-form__final-price"
      );
    }

    connectedCallback() {
      if (!this.relatedForm) return;
      this.mainInput = this.relatedForm.querySelector("[name='selling_plan']");
      this.currentVariantId =
        this.relatedForm.querySelector("[name='id']").value;
      this.relatedForm.addEventListener(
        "variant:changed",
        this.onVariantChanged.bind(this)
      );
      this.purchaseOptions.forEach((option) => {
        option.addEventListener("change", this.optionUpdated.bind(this));
      });
      this.purchaseOptionsRef.forEach((option) => {
        option.addEventListener("change", this.optionRefUpdated.bind(this));
      });
      this.querySelectorAll("[name='frequency-select']").forEach((option) => {
        option.addEventListener("change", this.optionUpdated.bind(this));
      });
      this.initValues();
    }

    initValues() {
      const selectedOption = this.querySelector(
        "input[name='selling_plan_type']:checked"
      );
      const selectedPlan = this.querySelector(
        "[name='frequency-select'] :checked"
      );
      if (selectedOption.dataset.type == "sub" && selectedPlan) {
        this.mainInput.value = selectedPlan.dataset.planId;
        const currentSellingPlans =
          this.geVariantsSellingPlansData()?.[this.currentVariantId];
        if (currentSellingPlans && currentSellingPlans.length > 0) {
          const currentPlanDetails = currentSellingPlans.find(
            (plan) => plan.id == selectedPlan.dataset.planId
          );
          if (currentPlanDetails) {
            const currentPlanPrice = currentPlanDetails.price;
            const compareAtPrice = currentPlanDetails.compare_at_price;
            
            this.priceReferences.forEach((priceLabel) => {
              if (compareAtPrice && compareAtPrice !== "" && parseFloat(compareAtPrice) > parseFloat(currentPlanPrice) && selectedOption.dataset.type == "otp") {
                priceLabel.innerHTML = `<del>$${compareAtPrice}</del> $${currentPlanPrice}`;
              } else {
                priceLabel.innerHTML = "$" + currentPlanPrice;
              }
            });
          }
        }
        const selectedOptionRef = document.querySelector(
          `[name='selling_plan_type_ref'][data-type='${selectedOption.dataset.type}']`
        );

        if (selectedOptionRef) {
          selectedOptionRef.checked = true;
        }
      }

    }

    optionUpdated(updateRef = true) { 
      const selectedOption = this.querySelector(
        "input[name='selling_plan_type']:checked"
      );
      if(updateRef) {
        const selectedOptionRef = document.querySelector(
          `[name='selling_plan_type_ref'][data-type='${selectedOption.dataset.type}']`
        );
        selectedOptionRef.checked = true;
      }
      const selectedPlan = this.querySelector(
        "[name='frequency-select'] :checked"
      );
      const currentSellingPlans =
        this.geVariantsSellingPlansData()?.[this.currentVariantId];
      if (selectedOption.dataset.type == "sub" && selectedPlan) {
        this.mainInput.value = selectedPlan.dataset.planId;
        if (currentSellingPlans && currentSellingPlans.length > 0) {
          const currentPlanDetails = currentSellingPlans.find(
            (plan) => plan.id == selectedPlan.dataset.planId
          );
          if (currentPlanDetails) {
            const newActives = this.querySelectorAll(
              `[data-plan-id='${currentPlanDetails.id}']`
            );
            newActives.forEach((newPlan) => {
              newPlan.classList.contains("th__modal--option")
                ? (newPlan.querySelector("input").checked = true)
                : (newPlan.selected = true);
            });
            const currentPlanPrice = currentPlanDetails.price;
            this.priceReferences.forEach((priceLabel) => {
              priceLabel.innerHTML = "$" + currentPlanPrice;
            });
          }
        }
      } else if (selectedOption.dataset.type == "otp") {
        this.mainInput.value = "";
        if (currentSellingPlans && currentSellingPlans.length > 0) {
          const currentPlanDetails = currentSellingPlans.find(
            (plan) => plan.id == "otp"
          );
          if (currentPlanDetails) {
            const currentPlanPrice = currentPlanDetails.price;
            const compareAtPrice = currentPlanDetails.compare_at_price;
            
            this.priceReferences.forEach((priceLabel) => {
              if (compareAtPrice && compareAtPrice !== "" && parseFloat(compareAtPrice) > parseFloat(currentPlanPrice)) {
                priceLabel.innerHTML = `<del>$${compareAtPrice}</del> $${currentPlanPrice}`;
              } else {
                priceLabel.innerHTML = "$" + currentPlanPrice;
              }
            });
          }
        }
      }
      const sellingPlansPrices = this.querySelectorAll(
        "[data-selling-plan-price]"
      );
      sellingPlansPrices.forEach((spPrice) => {
        const spPriceHolder = spPrice.querySelector(".td-selling-plan__price-holder");
        if (spPrice.dataset.sellingPlanPrice == "otp") {
          const price = currentSellingPlans[0].price;
          const compareAtPrice = currentSellingPlans[0].compare_at_price;
          
          if (compareAtPrice && compareAtPrice !== "" && parseFloat(compareAtPrice) > parseFloat(price)) {
            spPriceHolder.innerHTML = `<del>${compareAtPrice}</del> ${price}`;
          } else {
            spPriceHolder.innerHTML = price;
          }
        } else {
          spPriceHolder.innerHTML = currentSellingPlans[1].price;
        }
      });

    }

    optionRefUpdated(){
      const selectedOptionRef = document.querySelector(
        "input[name='selling_plan_type_ref']:checked"
      );
      const selectedOption = this.querySelector(
        `[name='selling_plan_type'][data-type='${selectedOptionRef.dataset.type}']`
      );
      selectedOption.checked = true;
      this.optionUpdated(false);
    }

    onVariantChanged(event) {
      const variant = event.detail.variant;
      this.priceReferences = document.querySelectorAll(
        ".td-product-form__final-price"
      );
      if (variant) {
        this.currentVariantId = variant.id;
        const selectedOption = this.querySelector(
          "input[name='selling_plan_type']:checked"
        );
        const selectedPlan = this.querySelector(
          "[name='frequency-select'] :checked"
        ).dataset.planId;
        const currentSellingPlans =
          this.geVariantsSellingPlansData()?.[variant.id];
        if (currentSellingPlans && currentSellingPlans.length > 0) {
          // Show/Hide available plans
          this.querySelector("[data-selling-plan='sub']").classList.remove(
            "td-hide"
          );
          const plansId = currentSellingPlans.map((plan) => plan.id.toString());
          const planSelectors = this.querySelectorAll("[data-plan-id]");
          planSelectors.forEach((plan) => {
            plansId.includes(plan.dataset.planId)
              ? plan.classList.remove("td-hide")
              : plan.classList.add("td-hide");
          });

          // Make sure current selected plan is available
          if (!plansId.includes(selectedPlan)) {
            this.mainInput.value = plansId[1];
            const newActives = this.querySelectorAll(
              `[data-plan-id='${plansId[1]}']`
            );
            newActives.forEach((newPlan) => {
              if (newPlan.classList.contains("th__modal--option")) {
                newPlan.querySelector("input").checked = true;
              } else {
                newPlan.closest("select").value = newPlan.value;
              }
            });
          }

          // Update the final price
          let currentPlanDetails = currentSellingPlans[0];
          if (selectedOption.dataset.type == "sub") {
            currentPlanDetails = currentSellingPlans.find(
              (plan) => plan.id == this.mainInput.value
            );
          }

          if (currentPlanDetails) {
            const currentPlanPrice = currentPlanDetails.price;
            this.priceReferences.forEach((priceLabel) => {
              priceLabel.innerHTML = "$" + currentPlanPrice;
            });
          }

          // New Prices
          const sellingPlansPrices = this.querySelectorAll(
            "[data-selling-plan-price]"
          );
          sellingPlansPrices.forEach((spPrice) => {
            const spPriceHolder = spPrice.querySelector(".td-selling-plan__price-holder");
            if (spPrice.dataset.sellingPlanPrice == "otp") {
              const price = currentSellingPlans[0].price;
              const compareAtPrice = currentSellingPlans[0].compare_at_price;
              
              if (compareAtPrice && compareAtPrice !== "" && parseFloat(compareAtPrice) > parseFloat(price)) {
                spPriceHolder.innerHTML = `<del>${compareAtPrice}</del> ${price}`;
              } else {
                spPriceHolder.innerHTML = price;
              }
            } else {
              spPriceHolder.innerHTML = currentSellingPlans[1].price;
            }
          });
        } else {
          this.querySelector("[data-selling-plan='sub']").classList.add(
            "td-hide"
          );
        }
      }
    }

    geVariantsSellingPlansData() {
      this.variantSellingPlansData =
        this.variantSellingPlansData ||
        getJson(
          this.querySelector(
            '[type="application/json"].product-variants-selling-plans'
          ).textContent
        );
      return this.variantSellingPlansData;
    }
  }

  customElements.define("selling-plans", SellingPlans);
}

if (!customElements.get("sticky-bottom")) {
  class StickyBottom extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const el = this;
      this.reference = this.dataset.reference;
      if (this.dataset.enabled == "false" || !this.reference) return;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      setTimeout(() => {
        el.onScroll();
      }, "1000");
    }

    onScroll() {
      const container = document.querySelector(this.reference);
      if (!container) return;
      const offSetContainer = container.offsetTop;
      if (offSetContainer < window.scrollY) {
        this.addSticky();
      } else {
        this.removeSticky();
      }
    }

    removeSticky() {
      document.body.classList.remove("sticky-bottom--active");
    }

    addSticky() {
      document.body.classList.add("sticky-bottom--active");
    }
  }

  customElements.define("sticky-bottom", StickyBottom);
}

function getJson(data) {
  try {
    return JSON.parse(data);
  } catch (err) {
    console.log(err);
    return {};
  }
}
